import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { CommunityGrowthCommissionItem } from "../../../../Redux/referral/types";
import {
  formatEarningsCurrency,
  formatEarningsDate,
  formatEarningsLongDate,
  normalizeEarningsStatus,
  statusLabel,
} from "../earningsAdapters";

const statusClass = (status: string) =>
  `community-status community-status-${normalizeEarningsStatus(status)}`;

interface Props {
  data: CommunityGrowthCommissionItem[];
}

const MrcCommissionTable = ({ data }: Props) => {
  return (
    <div className="community-desktop-list">
      {(data || []).map((item, index) => (
        <article className="community-desktop-card" key={index}>
          <div className="community-meta-row">
            <div>
              <span>Achieved Date</span>
              <strong>
                {formatEarningsDate(item.achievedDate || item.date)}
              </strong>
            </div>
            <div>
              <span>Order No</span>
              <strong>{item.orderNo || "—"}</strong>
            </div>
            <div>
              <span>Achievement Details</span>
              <strong>{item.referralMilestone}</strong>
            </div>
            <div className="community-status-cell">
              <span>Status</span>
              <span className={statusClass(item.receivedStatus)}>
                {statusLabel(item.receivedStatus)}
              </span>
            </div>
          </div>

          <div className="community-record-body">
            <div className="community-purchase-kicker">
              PURCHASED ON {formatEarningsLongDate(item.date).toUpperCase()}
            </div>

            <div className="community-product-row">
              <img
                src={item.productDetails?.image || "../../assets/img/women/women-4.png"}
                alt=""
                className="community-product-image"
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    "../../assets/img/women/women-4.png";
                }}
              />
              <div className="community-product-copy">
                <h2>{item.productDetails?.productName || "N/A"}</h2>
                <p>{item.referralMilestone}</p>
                <div className="community-product-actions">
                  <Link
                    className="community-primary-button"
                    to="/MrcCommissonDetails"
                  >
                    <Eye size={16} />
                    View Details
                  </Link>
                  <span>
                    Salar Code:{" "}
                    <strong>{item.productDetails?.salarCode || "-"}</strong>
                  </span>
                </div>
              </div>
            </div>

            <div className="community-summary-grid">
              <div>
                <span>Salar Shopping Voucher</span>
                <strong>
                  {formatEarningsCurrency(item.productDetails?.price)}
                </strong>
              </div>
              <div>
                <span>Received SCGR Incentive</span>
                <strong>
                  {formatEarningsCurrency(item.grossAmount ?? item.receivedSCGRCommission)}
                </strong>
              </div>
              <div>
                <span>TDS</span>
                <strong>
                  {formatEarningsCurrency(item.tdsAmount ?? 0)}
                  {item.tdsIsEstimated ? " (est)" : ""}
                </strong>
              </div>
              <div>
                <span>Net Credited</span>
                <strong>
                  {formatEarningsCurrency(item.netAmount ?? item.receivedSCGRCommission)}
                </strong>
              </div>
              <div>
                <span>Received From</span>
                <strong>{item.receivedFrom || item.customerId || "—"}</strong>
              </div>
              <div>
                <span>Milestone</span>
                <strong>{item.referralMilestone}</strong>
              </div>
            </div>

            {item.bonusDetails && (
              <div className="community-bonus-strip">
                <div>
                  <span>BONUS SCGR INCENTIVE</span>
                  <strong>Level {item.bonusDetails.levelNo}</strong>
                </div>
                <div>
                  <span>RECEIVED BONUS</span>
                  <strong>
                    {formatEarningsCurrency(
                      item.bonusDetails.bonusReceivedCommunityGrowthCommission,
                    )}
                  </strong>
                </div>
              </div>
            )}
          </div>
        </article>
      ))}
    </div>
  );
};

export default MrcCommissionTable;
